import React from 'react';
import { HStack, VStack } from '../layouts/stack.layout';
import Heading from '../typography/v2/heading';
import Text from '../typography/v2/text';

type EmptyCardProps = {
  variant: 'notifications' | 'bookmarks' | 'channel' | 'genre';
};

const HEADING_FOR = {
  notifications: 'No Notifications',
  bookmarks: 'No Bookmarks',
  channel: 'No Channel',
  genre: 'No Genre',
};

const TEXT_FOR = {
  notifications: 'Mentions & announcements will be shown here',
  bookmarks: 'Save posts and articles to read later',
  channel: 'No such channel has been found.',
  genre: 'No such genre has been found.',
};

export default function EmptyCard(props: EmptyCardProps) {
  const { variant } = props;
  return (
    <VStack extensions="w-full py-3" align="center">
      <Heading casing="uppercase" variant="primary">
        {HEADING_FOR[variant]}
      </Heading>
      <HStack justify="center" extensions="rounded-bl-lg rounded-br-lg">
        <Text color="info">{TEXT_FOR[variant]}</Text>
      </HStack>
    </VStack>
  );
}
